/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/sap-sf-ec/SapSfEcInboundConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SapSfEcInboundConfigCardTestIds = {
  btnEditSapSfEcConfig: "btn-edit-sap-sf-ec-config",
  cardTitleSapSfEcConfig: "card-title-sap-sf-ec-config",
  sapSfEcConfigSection: "sap-sf-ec-config-section"
} as const;
